import styled, { keyframes } from "styled-components";

const fadeIn = keyframes` from { opacity: 0; } to { opacity: 1; } `;
const slideIn = keyframes` from { transform: translateY(24px) scale(0.98); opacity: 0; } to { transform: translateY(0) scale(1); opacity: 1; } `;
const shine = keyframes` 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } `;

export const WarningOverlay = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 5, 14, 0.94);
  backdrop-filter: blur(6px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 11000;
  padding: 24px;
  box-sizing: border-box;
  animation: ${fadeIn} 0.3s ease-in-out;

  @media (max-width: 600px) {
    padding: 14px;
    align-items: flex-start;
    overflow-y: auto;
  }
`;

export const WarningContainer = styled.div`
  position: relative;
  background: linear-gradient(165deg, #10151f 0%, #0a0e16 100%);
  border-radius: 24px;
  border: 1px solid rgba(212, 175, 55, 0.45);
  overflow: hidden;
  box-sizing: border-box;
  max-width: 780px;
  width: 100%;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.65),
    0 0 60px rgba(212, 175, 55, 0.08);
  animation: ${slideIn} 0.5s cubic-bezier(0.16, 1, 0.3, 1);

  @media (max-width: 600px) {
    border-radius: 18px;
    margin: auto;
    max-height: none;
  }
`;

/* Faixa dourada superior animada */
export const TopAccent = styled.div`
  height: 5px;
  width: 100%;
  flex-shrink: 0;
  background: linear-gradient(
    90deg,
    #b8860b,
    #f5d76e,
    #d4af37,
    #f5d76e,
    #b8860b
  );
  background-size: 200% 100%;
  animation: ${shine} 4s linear infinite;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 48px 18px;
  box-sizing: border-box;
  flex-shrink: 0;

  @media (max-width: 600px) {
    padding: 26px 22px 14px;
  }
`;

export const IconCircle = styled.div`
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: radial-gradient(
    circle at 30% 25%,
    rgba(212, 175, 55, 0.28),
    rgba(212, 175, 55, 0.06) 70%
  );
  border: 2px solid #d4af37;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  box-shadow: 0 0 26px rgba(212, 175, 55, 0.25);

  svg {
    font-size: 32px;
    color: #f5d76e;
  }

  @media (max-width: 600px) {
    width: 60px;
    height: 60px;
    margin-bottom: 12px;

    svg {
      font-size: 26px;
    }
  }
`;

export const Badge = styled.span`
  background: transparent;
  color: #f5d76e;
  border: 1px solid rgba(212, 175, 55, 0.6);
  padding: 6px 20px;
  box-sizing: border-box;
  border-radius: 30px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 4px;
  text-transform: uppercase;
`;

export const Title = styled.h2`
  margin: 16px 0 0;
  font-size: 26px;
  font-weight: 900;
  text-transform: uppercase;
  background: linear-gradient(90deg, #f5d76e, #d4af37, #f5d76e);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1.25;
  letter-spacing: 1px;

  @media (max-width: 600px) {
    font-size: 20px;
  }
`;

export const Divider = styled.div`
  width: 70px;
  height: 3px;
  border-radius: 3px;
  background: linear-gradient(90deg, transparent, #d4af37, transparent);
  margin: 14px auto 0;
`;

export const Body = styled.div`
  padding: 8px 48px 0;
  box-sizing: border-box;
  overflow-y: auto;
  flex: 1 1 auto;

  scrollbar-width: thin;
  scrollbar-color: rgba(212, 175, 55, 0.5) transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(212, 175, 55, 0.45);
    border-radius: 6px;
  }

  @media (max-width: 600px) {
    padding: 4px 22px 0;
  }
`;

export const TextContent = styled.div`
  font-size: 15.5px;
  line-height: 1.75;
  color: #c8cfdb;
  text-align: justify;

  p {
    margin: 0 0 16px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    color: #f5d76e;
    font-weight: 800;
  }

  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 1.65;
    text-align: left;
  }
`;

/* Destaque para informações-chave do comunicado */
export const Highlight = styled.div`
  margin: 20px 0;
  padding: 16px 20px;
  box-sizing: border-box;
  background: rgba(212, 175, 55, 0.08);
  border: 1px solid rgba(212, 175, 55, 0.25);
  border-left: 4px solid #d4af37;
  border-radius: 10px;
  font-size: 15px;
  line-height: 1.65;
  color: #d6dce6;

  strong {
    color: #f5d76e;
    font-weight: 800;
  }

  @media (max-width: 600px) {
    font-size: 13.5px;
    padding: 14px 16px;
  }
`;

export const Footer = styled.div`
  padding: 24px 48px 32px;
  box-sizing: border-box;
  flex-shrink: 0;
  background: linear-gradient(
    180deg,
    rgba(10, 14, 22, 0) 0%,
    rgba(10, 14, 22, 1) 40%
  );

  @media (max-width: 600px) {
    padding: 20px 22px 26px;
  }
`;

export const AcceptButton = styled.button`
  width: 100%;
  background: linear-gradient(135deg, #d4af37 0%, #b8860b 100%);
  color: #10151f;
  padding: 17px 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 14px;
  font-size: 16px;
  font-weight: 900;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.1);
    box-shadow: 0 12px 28px rgba(212, 175, 55, 0.35);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 600px) {
    padding: 15px 20px;
    font-size: 15px;
  }
`;
